import PropTypes from 'prop-types';
import React from 'react';
const DelayRender = /*#__PURE__*/React.memo(_ref => {
  let {
    ms = 1000,
    children
  } = _ref;
  const [showing, setShowing] = React.useState();
  React.useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowing(true);
    }, ms);
    return () => timeoutId && clearTimeout(timeoutId);
  });
  return showing ? children : null;
});
DelayRender.propTypes = {
  /** Delay in milliseconds */
  ms: PropTypes.number
};
DelayRender.displayName = 'DelayRender';
export default DelayRender;